const EMPTY_TEXT = "--";

function toText(value) {
  if (value === null || value === undefined) {
    return "";
  }
  return String(value).trim();
}

function formatVariantDetails(value) {
  if (Array.isArray(value)) {
    return value.map(formatVariantDetails).filter(Boolean).join(", ");
  }

  if (value && typeof value === "object") {
    const label = toText(value.variantName || value.name || value.label);
    const detail = toText(value.variantValue || value.value || value.text);
    if (label && detail) {
      return `${label}: ${detail}`;
    }
    return detail || label;
  }

  return toText(value);
}

/**
 * 将新扫码接口的 orderItem 明细转成弹窗展示文本。
 * bundle 展示“商品名, 规格”；单品只展示规格，商品名仍由 Item Name 行展示。
 */
function formatOrderItemDetails(orderItem) {
  const items = orderItem && orderItem.items;
  if (!Array.isArray(items)) {
    return EMPTY_TEXT;
  }

  const isBundle = orderItem.type === 2 || orderItem.type === "2";
  const text = items
    .map((item) => {
      if (!item || typeof item !== "object") {
        return toText(item);
      }

      const itemName = toText(item.name);
      const variantText = formatVariantDetails(item.variantDetails);
      const hasVariantText = variantText && variantText !== itemName;

      // bundle 里需要把子商品名和自己的规格绑定展示，避免多个规格混在一起。
      // 后端无规格时可能把 variantDetails 回成商品名，这种情况只显示一次商品名。
      if (isBundle && itemName && hasVariantText) {
        return `${itemName}, ${variantText}`;
      }
      if (isBundle) {
        return itemName || (hasVariantText ? variantText : "");
      }
      return hasVariantText ? variantText : "";
    })
    .filter(Boolean)
    .join("\n");

  return text || EMPTY_TEXT;
}

module.exports = {
  formatOrderItemDetails,
};
